import { SetOnBeforeUnload } from "../utils/SetOnBeforeUnload";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";

export class QDumpPlanRFC extends QRFC {
  constructor() {
    super();
  }

  InitDumpPlanRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, mode, planID) {
    this.AddParameter("data", planID);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    var wsMgr = callBackObj;
    var r = JSON.parse(response);
    var success = r["success"];
    if (success) {
      var u = wsMgr.GetUploadMgr();
      var accountName = wsMgr.GetAccountName();
      var username = wsMgr.GetUserName();
      var directory = "System";
      u.DoDownloadFile(accountName, username, directory, r["filename"]);
      SetOnBeforeUnload();
    } else {
      var alert = new QAlert();
      alert.InitAlert("Plan Export Failure", r["message"], null, wsMgr);
    }
  }
}
